import * as prismicH from '@prismicio/client'
import { FC } from 'react'
import { HomePageText } from '../../components/Text/HomePageText'
import { PRISMICTYPE_TO_ELEMENT } from './HomePagePrismicText.constants'
import { RichTextField } from '@prismicio/client'
import { SxProps, SystemProps, Theme } from '@mui/system'
import { TypographyVariants } from '../../components/Text/HomePageText.types'
import styled from '@emotion/styled'

export type HomePagePrismicTextProps = {
  richTextField?: RichTextField
  variant: TypographyVariants
  sx?: SxProps<Theme>
  onClick?: () => void
} & SystemProps<Theme>

const _HomePageText = styled(HomePageText)`
  & a {
    color: '#1F1F1F';
    text-decoration: underline;
    font-weight: inherit;
  }
`

/**
 * Wrapper around our Text component to render text coming from Prismic with our
 * default styling and Text component API. It enables certain styling: bold,
 * italics and other nested tags to be respected when specified in Prismic.
 *
 * ⚠️ This component doesn't not handle prismic links of type 'Link to a Document' only 'Link to the Web'
 * As such we can't use a linkResolver to handle linking to other prismic documents.
 * See https://prismic.io/docs/link-resolving-reactjs
 */
export const HomePagePrismicText: FC<HomePagePrismicTextProps> = ({ richTextField, ...rest }) => {
  if (!richTextField) return null
  if (!prismicH.isFilled.richText(richTextField)) return null

  const subText = richTextField?.[0]

  if (subText && 'text' in subText && !subText?.text) return null

  const textInnerHTML =
    prismicH.asHTML(richTextField, null, (type, _node, _content, children) => {
      // Stop once parent element (a.k.a outermost) is reached to avoid nested h1, p tags, etc.
      // given our _HomePageText already provides the outermost tag
      if (type === richTextField?.[0]?.type) return children
      else return null
    }) || ''

  return (
    <_HomePageText
      dangerouslySetInnerHTML={{ __html: textInnerHTML }}
      component={
        richTextField?.[0]?.type ? PRISMICTYPE_TO_ELEMENT?.[richTextField[0]?.type] : undefined
      }
      {...rest}
    />
  )
}
